// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '150',
}

const propTypes = {
  width: PropTypes.string,
}

// Component
function IconPin({ width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      viewBox="0 0 162.434 158.203"
    >
      <path
        className="a"
        fill="#0070f2"
        opacity="0.148"
        d="M87.761,0c34.58,0,37.465,7.9,37.465,41.43S92.68,92.419,62.613,102.144,0,74.961,0,41.43,53.181,0,87.761,0Z"
        transform="matrix(0.799, 0.602, -0.602, 0.799, 62.424, 0)"
      />
      <g transform="translate(19.975 41.02)">
        <path
          className="b"
          fill="#0056bf"
          d="M270.522,289.2l-11.308-11.327a1.885,1.885,0,0,0-3.219,1.331v26.4a1.885,1.885,0,0,0,1.289,1.787,1.862,1.862,0,0,0,.6.1,1.885,1.885,0,0,0,1.508-.754L270.7,291.657A1.885,1.885,0,0,0,270.522,289.2Z"
          transform="translate(-210.765 -232.119)"
        />
        <path
          className="c"
          fill="#fff"
          d="M227.107,302.622,215.8,298.852a1.885,1.885,0,0,0-2.386,2.382l7.539,22.616a1.884,1.884,0,0,0,1.79,1.289h.117a1.884,1.884,0,0,0,1.73-1.508l3.769-18.847A1.885,1.885,0,0,0,227.107,302.622Z"
          transform="translate(-175.627 -249.771)"
        />
        <path
          className="d"
          fill="#127ef8"
          d="M159.9,21.861a1.885,1.885,0,0,0-2.024-.087L86.263,63.237a1.885,1.885,0,0,0,.351,3.419l33.848,11.285,26.31,11.278a1.884,1.884,0,0,0,2.6-1.406l11.308-64.079A1.885,1.885,0,0,0,159.9,21.861Z"
          transform="translate(-70.248 -21.52)"
        />
        <g transform="translate(0 0.547)">
          <path
            className="c"
            fill="#fff"
            d="M266.589,23.534c.608-.845.712-1.207.378-1.475-.5-.4-.827.152-1.48.811L215.611,73.763l14.184,4.9Z"
            transform="translate(-177.516 -21.922)"
          />
          <path
            className="e"
            fill="#fa6383"
            d="M4.606,390.505a1.884,1.884,0,0,1-1.278-.5q-1.41-1.3-2.774-2.665a1.886,1.886,0,0,1,2.665-2.669q1.312,1.312,2.665,2.559a1.885,1.885,0,0,1-1.278,3.272Z"
            transform="translate(0 -320.602)"
          />
          <path
            className="e"
            fill="#fa6383"
            d="M75.915,441.759a27.128,27.128,0,0,1-5.405-.562,1.885,1.885,0,0,1,.608-3.72c.049.008.1.018.146.03a23.372,23.372,0,0,0,4.663.482h.859a1.787,1.787,0,0,1,1.956,1.813,1.885,1.885,0,0,1-1.813,1.953h-.984Zm-13.505-3.607a1.885,1.885,0,0,1-.867-.211,49.22,49.22,0,0,1-5.356-3.253,1.885,1.885,0,0,1,2.148-3.095,44.7,44.7,0,0,0,4.938,3.015,1.885,1.885,0,0,1-.867,3.558Z"
            transform="translate(-45.633 -359.436)"
          />
          <path
            className="e"
            fill="#fa6383"
            d="M217.382,453.685a1.885,1.885,0,0,1-.754-3.619,27.388,27.388,0,0,0,3.155-1.6,1.885,1.885,0,0,1,1.915,3.245,31.315,31.315,0,0,1-3.588,1.821A1.89,1.89,0,0,1,217.382,453.685Z"
            transform="translate(-177.41 -373.382)"
          />
        </g>
      </g>
    </svg>
  )
}

IconPin.defaultProps = defaultProps
IconPin.propTypes = propTypes

export default IconPin
